exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".unit1d .unit-video .video{background-image:url(https://i.vimeocdn.com/video/710442760.webp?mw=1200&mh=675&q=70)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/diagrams/1/1d/diagram1/diagram1.scss
// module id = 975
// module chunks = 0